import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css';
Vue.use(Vuetify);
export default new Vuetify({
    icons: {
        iconfont: "fa"
    },
    theme: {
        dark: false,
        default: 'light',
        themes: {
            light: {
                primary: "#133467",
                secondary: "#0c1f3e",
                menu: "#425c86",
                secondarymenu: "#76a484",
                accent: "#8c9eff",
                error: "#b71c1c"
            }
        }
    }
});
